// @flow

import React, { Component } from "react";
import DocumentTitle from "react-document-title";

import {
  AppTitle,
  AppSubtitle,
  SectionTitle,
  SplitChild,
  SplitContainer
} from "../styles";
import InputField from "../InputField";
import A from "../A";
import Timeline from "./Timeline";

export default class Milestones extends Component {
  state = {
    annualExpenses: 40000,
    netWorth: 0
  };

  _updateField = (id: string, value: number) =>
    this.setState(oldState => ({ ...oldState, [id]: value }));

  render() {
    return (
      <div>
        <DocumentTitle title="Milestones of FI | OneNumberUp" />
        <AppTitle>Milestones of FI</AppTitle>
        <AppSubtitle>
          Wondering where you stack up against ChooseFI's{" "}
          <A target="_blank" href="http://www.choosefi.com/032-milestones-fi/">
            milestones of FI
          </A>? Track your progress here and share it with{" "}
          <A target="_blank" href="http://choosefi.com/facebook">
            the community
          </A>!
        </AppSubtitle>
        <SplitContainer>
          <SplitChild narrow>
            <SectionTitle centered>Your Numbers</SectionTitle>
            <InputField
              id="annualExpenses"
              label="Annual Expenses"
              helpText="Put your total annual after-tax expenses here. For example, if you make $100,000 a year, pay $20,000 in taxes and save $45,000, you would enter $35,000 here."
              onUpdate={this._updateField}
              values={this.state}
            />
            <InputField
              id="netWorth"
              label="Net Worth"
              helpText={
                <div>
                  Enter your current net worth. You can use{" "}
                  <A href="https://www.personalcapital.com/">
                    Personal Capital
                  </A>{" "}
                  to calculate it.
                </div>
              }
              onUpdate={this._updateField}
              values={this.state}
            />
          </SplitChild>
          <SplitChild>
            <SectionTitle centered>Your Milestones</SectionTitle>
            <Timeline
              netWorth={this.state.netWorth}
              annualExpenses={this.state.annualExpenses}
            />
          </SplitChild>

        </SplitContainer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/milestones/index.js